import {
  COORDINATE_FORMAT_OPTIONS,
  normalizeCoordinateFormat,
} from "./coordinateFormat"

export { COORDINATE_FORMAT_OPTIONS }

export const PREFERENCES_STORAGE_KEY = "magpie-preferences"
export const DEFAULT_USER_PREFERENCES = Object.freeze({
  version: 1,
  coordinateFormat: "ddm",
})

const VALID_FORMATS = new Set(COORDINATE_FORMAT_OPTIONS.map(({ value }) => value))

function defaults() {
  return { ...DEFAULT_USER_PREFERENCES }
}

function browserStorage() {
  try {
    return globalThis.localStorage
  } catch {
    return null
  }
}

export function loadUserPreferences(storage = browserStorage()) {
  if (!storage) return defaults()
  try {
    const raw = storage.getItem(PREFERENCES_STORAGE_KEY)
    if (!raw) return defaults()
    const parsed = JSON.parse(raw)
    if (parsed?.version !== 1 || !VALID_FORMATS.has(parsed?.coordinateFormat)) return defaults()
    return { version: 1, coordinateFormat: normalizeCoordinateFormat(parsed.coordinateFormat) }
  } catch {
    return defaults()
  }
}

export function saveUserPreferences(candidate, storage = browserStorage()) {
  if (!VALID_FORMATS.has(candidate?.coordinateFormat)) {
    throw new Error("Invalid coordinate format preference.")
  }
  if (!storage) throw new Error("Could not save settings in this browser.")

  const saved = { version: 1, coordinateFormat: candidate.coordinateFormat }
  try {
    storage.setItem(PREFERENCES_STORAGE_KEY, JSON.stringify(saved))
  } catch {
    throw new Error("Could not save settings in this browser.")
  }
  return saved
}
